"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ButtonGroup;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ButtonGroup({
  orientation = 'horizontal',
  size = 'md',
  block,
  style,
  children
}) {
  const classes = [];
  if (orientation === 'vertical') classes.push('btn-group-vertical');else classes.push('btn-group');
  if (size !== 'md') {
    classes.push('btn-group-' + size);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' '),
    role: "group",
    style: block ? {
      display: 'block'
    } : style || undefined
  }, children);
}